export enum GroupKind {
  department = 'Department',
  status = 'Status',
  location = 'Location',
  location_name = 'Location',
  country = 'Country',
  country_name = 'Country',
  state = 'State/Region',
  state_name = 'State/Region',
  recruiter = 'Recruiter',
  hiring_manager = 'Hiring Manager',
  work_model = 'Work model',
}

export enum ColumnId {
  title = 'Title',
  guid = 'Guid',
  status = 'Status',
  department_name = 'Department',
  created_at = 'Date created',
  location = 'Location',
  location_address = 'Location address',
  location_name = 'Location name',
  state_name = 'State/Region',
  jobs = 'Assigned job',
  followers = 'Followers',
  hires_count = 'Hires',
  recruiter_name = 'Recruiter',
  hiring_manager_name = 'Hiring Manager',
  openings_count = 'No of openings',
  reason_for_opening = 'Reason for opening',
  requester_name = 'Approval requested by',
  manage = 'Manage',
  work_model = 'Work model',
  priority = 'Priority',
}

export enum Scope {
  active = 'Active',
  archived = 'Archived',
  need_my_approval = 'Need my approval',
  requested_by_me = 'Requested by me',
  active_approved = 'Active approved',
}
